
import React from 'react';
import { motion } from 'framer-motion';
import { Loader } from 'lucide-react';
import { cn } from '@/lib/utils';

interface LoadingSpinnerProps {
  size?: 'xs' | 'sm' | 'md' | 'lg';
  color?: 'primary' | 'white' | 'gray';
  className?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'md',
  color = 'primary',
  className
}) => {
  // Define size in pixels
  const sizeMap = {
    xs: 12,
    sm: 16,
    md: 24,
    lg: 32
  };
  
  // Define colors
  const colorMap = {
    primary: 'text-blue-600',
    white: 'text-white',
    gray: 'text-gray-400'
  };
  
  return (
    <motion.div 
      initial={{ opacity: 0 }}
      animate={{ 
        opacity: 1,
        rotate: 360 
      }}
      transition={{ 
        duration: 1,
        repeat: Infinity,
        ease: "linear"
      }}
      className={cn("inline-flex items-center justify-center", className)}
    >
      <Loader size={sizeMap[size]} className={cn("animate-spin", colorMap[color])} />
    </motion.div>
  );
};

export default LoadingSpinner;
